/**
 * Index the radio-group keyboard pattern moves to for `key`, or `null` for a
 * key it does not handle. Left/Right follow the reading direction, so they
 * swap in a right-to-left layout.
 */
export function segmented_target_index(
  key: string,
  from: number,
  count: number,
  rtl: boolean,
): number | null {
  const forward = rtl ? 'ArrowLeft' : 'ArrowRight';
  const backward = rtl ? 'ArrowRight' : 'ArrowLeft';
  if (key === forward || key === 'ArrowDown') return (from + 1) % count;
  if (key === backward || key === 'ArrowUp') return (from - 1 + count) % count;
  if (key === 'Home') return 0;
  if (key === 'End') return count - 1;
  return null;
}
